import React, { useEffect, useState } from 'react';
import { Device, Call } from '@twilio/voice-sdk';

import { Codec, CALL_STATE } from '../../global/enums';
import { Box, Button } from '@mui/material';
import { LocalPhoneOutlined } from '@mui/icons-material';
import useSession from '../../hooks/useSession';
import Timer from '../../components/Timer';
const stateLabel = {
  [CALL_STATE.CONNECTING]: 'Connecting...',
  [CALL_STATE.READY]: 'ready',
  [CALL_STATE.ON_CALL]: 'Hang up',
  [CALL_STATE.OFFLINE]: 'Voice Call',
};

interface IVoiceCallTwilioProps {
  styles: any;
  phoneNumber: string;
}

const VoiceCallTwilio = ({ styles, phoneNumber }: IVoiceCallTwilioProps) => {
  const [sipToken, setSipToken] = useState<string>('');
  const [callState, setCallState] = useState<CALL_STATE>(CALL_STATE.OFFLINE);
  const [connection, setConnection] = useState(null);
  const [device, setDevice] = useState<undefined | Device>();
  const [call, setCall] = useState<undefined | Call>();

  const { getSipToken } = useSession();

  const {
    data: sipTokenData,
    isLoading: isGettingSipToken,
    refetch: fetchSipToken,
  } = getSipToken;

  useEffect(() => {
    console.log('::::sipToken:', sipToken);
    console.log('::::callState:', callState);

    if (sipToken && callState === CALL_STATE.CONNECTING) {
      init();
    } else {
      console.log('do SIP call disconnect');
      call?.disconnect();
      device?.destroy();
      setDevice(undefined);
      setCall(undefined);
      setCallState(CALL_STATE.OFFLINE);
    }
  }, [sipToken]);

  useEffect(() => {
    if (callState === CALL_STATE.READY) {
      makeCall();
    }
  }, [callState]);

  const init = async () => {
    console.log('::::::::Device init...');
    try {
      console.log('::::::::Connect with token:', sipToken);
      const device = new Device(sipToken, {
        logLevel: 1,
        codecPreferences: [Codec.Opus, Codec.PCMU],
      });
      device.register();
      setDevice(device);
      device.addListener('connect', (device) => {
        console.log('::::::::Connect event listener added .....');
        return device;
      });

      device.on('registered', () => {
        console.log('::::::::Agent registered');
        setCallState(CALL_STATE.READY);
      });

      device.on('connect', (connection) => {
        console.log('::::::::Call connect');
        setConnection(connection);
        setCallState(CALL_STATE.ON_CALL);
      });

      device.on('disconnect', () => {
        console.log('::::::::Disconnect event');
        //setCallState(CALL_STATE.READY)
        setConnection(null);
      });

      return () => {
        setCallState(CALL_STATE.OFFLINE);
        device?.destroy();
        setDevice(undefined);
        setCall(undefined);
      };
    } catch (error) {
      console.log('Error', error);
    }
  };

  const startVoiceCall = async () => {
    console.log(`::::start voice call ${callState}`, 'callState:', callState);

    if (callState === CALL_STATE.OFFLINE) {
      setCallState(CALL_STATE.CONNECTING);
      console.log('call mobile');
      const response = await fetchSipToken();

      console.log('::::fetchSipToken response:', response?.data);

      setSipToken(response?.data?.token);
    } else if (callState === CALL_STATE.ON_CALL) {
      setSipToken('');
    }
  };

  const makeCall = async () => {
    console.log('::::::::Call connect...');

    const params: Record<string, string> = { To: phoneNumber };
    setCallState(CALL_STATE.CONNECTING);
    device?.emit('connect');
    const call = await device?.connect({
      params: params,
      rtcConstraints: {
        audio: true,
      },
    });

    setCall(call);
    if (call) {
      call.on('accept', () => {
        setConnection(connection);
        setCallState(CALL_STATE.ON_CALL);
        console.log('::::::::call accepted');
      });

      call.on('disconnect', () => {
        console.log('::::::::The call has been disconnected.');
        //setCallState(CALL_STATE.READY)
        setConnection(null);
      });

      call.on('cancel', () => {
        console.log('::::::::The call was canceled.');
      });

      call.on('reject', () => {
        console.log('::::::::The call was rejected.');
      });
    }
  };

  return (
    <>
      <Button onClick={startVoiceCall} sx={styles.callMobile}>
        <LocalPhoneOutlined sx={{ marginRight: '0.5rem' }} />
        {stateLabel[callState]}
      </Button>
      <Box color={'#aaa'}>
        {callState === CALL_STATE.ON_CALL && <Timer />}
        <div>{callState}</div>
      </Box>
    </>
  );
};

export default VoiceCallTwilio;
